import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { FunnelResultsPage } from './ResultsPage';
import { FunnelGateHomePage } from './HomePage';
import { GatePath } from '../types';
export const FunnelGatePages = _ref => {
  let handlers = _ref.handlers,
    externalViewer = _ref.externalViewer;
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.ModalsProvider, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: GatePath.RESULTS,
    render: () => /*#__PURE__*/React.createElement(FunnelResultsPage, {
      handlers: handlers,
      externalViewer: externalViewer
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: GatePath.GATE,
    render: () => /*#__PURE__*/React.createElement(FunnelGateHomePage, {
      handlers: handlers,
      externalViewer: externalViewer
    })
  })));
};
//# sourceMappingURL=FunnelGatePages.js.map